import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import cn from '../../../utils/cn';
import Portal from '../../../atoms/Portal';
import { IconClose } from '../../../icons';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverClose = PopoverPrimitive.Close;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    arrow?: boolean;
    close?: boolean;
  }
>(function PopoverContent(
  {
    className,
    align = 'center',
    sideOffset = 4,
    arrow = true,
    arrowPadding = 25,
    collisionPadding = 15,
    children,
    close = true,
    ...props
  },
  ref,
) {
  return (
    <Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        arrowPadding={arrowPadding}
        collisionPadding={collisionPadding}
        className={cn(
          'z-1050 pointer-events-auto w-80 rounded-xl bg-white p-5 text-neutral-700 shadow-xl outline-none ring-1 ring-neutral-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        {...props}
      >
        {children}

        {close && (
          <PopoverPrimitive.Close
            className="absolute right-5 top-5 cursor-pointer items-center justify-center rounded bg-black/50 p-1 text-white outline-none transition-all hover:bg-black/60 focus:ring-2 focus:ring-black/20"
            aria-label="Fermer"
          >
            <IconClose className="h-3 w-3" />
          </PopoverPrimitive.Close>
        )}

        {arrow && (
          <PopoverPrimitive.Arrow asChild>
            <svg width={10} height={5} viewBox="0 0 10 5" preserveAspectRatio="none">
              {/* Main triangle fill */}
              <path d="M0 0L5 5L10 0Z" fill="white" />

              {/* Left border */}
              <line
                x1="0"
                y1="0"
                x2="5"
                y2="5"
                className="stroke-neutral-300"
                strokeWidth="1"
              />

              {/* Right border */}
              <line
                x1="10"
                y1="0"
                x2="5"
                y2="5"
                className="stroke-neutral-300"
                strokeWidth="1"
              />
            </svg>
          </PopoverPrimitive.Arrow>
        )}
      </PopoverPrimitive.Content>
    </Portal>
  );
});

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverClose };
